export default class CreateWalletRequest {
    accountId: string = "";
    name: string = "";
    currency: string = "";
    secondaryWalletTypeCode: string = "";
}